import { motion } from "motion/react";
import Header from "../../../components/feature/Header";
import Footer from "../../../components/feature/Footer";
import WhatsAppFloating from "../../../components/feature/WhatsAppFloating";
import CookieBanner from "../../../components/feature/CookieBanner";
import QuoteFormSection from "../../../pages/home/components/QuoteFormSection";
import SEO from "@/components/feature/SEO";

const cuando = [
  { emoji: "🚿", title: "Ventanas pequeñas", desc: "Baños, aseos, despensas o cuartos de lavado. Ventanas que no se abren mucho pero necesitan ventilación." },
  { emoji: "🪜", title: "Aberturas poco usadas", desc: "Ventanas de trasteros, garajes o áticos que solo abres de vez en cuando. No necesitas sistema enrollable." },
  { emoji: "💰", title: "Presupuesto ajustado", desc: "La opción más económica del mercado. Desde 60€ tienes protección completa contra mosquitos." },
];

const limitaciones = [
  { icon: "ri-forbid-line", title: "No se retiran fácilmente", desc: "Una vez instaladas, quedan fijas en la ventana. Si necesitas limpiar el cristal por fuera, hay que desmontar el marco completo." },
  { icon: "ri-walk-line", title: "No aptas para entradas frecuentes", desc: "No sirven para puertas o ventanas que abras y cierres muchas veces al día. Para eso mejor enrollable o corredera." },
  { icon: "ri-sun-line", title: "Bloquean algo de luz", desc: "Como la tela está siempre puesta, reduce ligeramente la entrada de luz natural. Es mínimo pero perceptible." },
];

const faqs = [
  { q: "¿Se pueden desmontar para limpiar?", a: "Sí, se desmontan fácilmente desatornillando los pestillos de marco. Puedes sacar la mosquitera, limpiarla con agua y jabón y volver a colocarla en minutos." },
  { q: "¿Durán las telas de las fijas?", a: "Sí, incluso más que las enrollables porque no sufren tensión ni enrollado. La fibra de vidrio dura hasta 10 años en una fija." },
  { q: "¿Sirven para ventanas de oscilobatiente?", a: "Sí, las fabricamos a medida para cualquier tipo de ventana: abatible, oscilobatiente, corredera o pivotante." },
  { q: "¿Qué pasa si se rompe la tela?", a: "Cambiamos la tela sin cambiar el marco. Es un trabajo rápido y económico que hacemos en tu casa." },
  { q: "¿Incluyen garantía?", a: "Sí, 2 años en marco y tela. Si se despega o se rompe por defecto de fabricación, la sustituimos gratis." },
];

export default function MosquiterasFijas() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Mosquiteras Fijas Málaga | Marco con Tela desde 60€"
        description="Mosquiteras fijas en Málaga desde 60€. Solución sencilla y económica para ventanas pequeñas. Presupuesto gratis. ☎ 951 12 07 70"
        canonical="/mosquiteras/mosquiteras-fijas/"
        breadcrumbs={[{ name: "Inicio", path: "/" }, { name: "Mosquiteras", path: "/mosquiteras" }, { name: "Mosquiteras fijas" }]}
      />
      <Header />
      <main>
        {/* HERO */}
        <section className="bg-white pt-24 md:pt-[72px]">
          <div className="max-w-container mx-auto px-4 md:px-6 py-12 md:py-24">
            <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
              <div className="w-full lg:w-[55%] flex flex-col gap-6">
                <div className="inline-flex items-center gap-2 bg-accent text-text-primary font-body font-semibold text-sm px-4 py-2 rounded-pill w-fit">
                  <span>⚡</span> Desde 60€
                </div>
                <h1 className="font-heading font-extrabold text-4xl md:text-5xl lg:text-[56px] leading-[1.1] text-text-primary">
                  Mosquiteras Fijas en Málaga: La Opción Económica
                </h1>
                <p className="font-body text-lg md:text-xl text-text-secondary leading-relaxed max-w-xl">
                  Marco fijo con tela. La solución más sencilla y económica desde 60€. Perfecta para ventanas pequeñas y aberturas poco usadas.
                </p>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                  <a
                    href="tel:+34951120770"
                    className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold text-lg md:text-xl px-8 py-4 rounded-pill transition-colors whitespace-nowrap"
                  >
                    <span>📞</span> 951 12 07 70
                  </a>
                  <a
                    href="#presupuesto"
                    className="inline-flex items-center gap-2 border-2 border-secondary text-secondary hover:bg-secondary hover:text-white font-body font-semibold text-base px-6 py-3.5 rounded-pill transition-colors whitespace-nowrap"
                  >
                    Pedir presupuesto
                  </a>
                </div>
                <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-2">
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Desde 60€</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Instalación 30 min</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Marco aluminio</span>
                </div>
              </div>
              <div className="w-full lg:w-[45%] relative">
                <div className="relative rounded-3xl overflow-hidden lg:rotate-1 shadow-xl">
                  <div className="absolute inset-0 bg-blue-900/35 z-10 pointer-events-none"></div>
                  <img
                    src="https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=1200&q=80&auto=format&fit=crop"
                    alt="Mosquitera fija en ventana pequeña Málaga"
                    className="w-full h-auto object-cover aspect-[4/3]"
                    loading="eager"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CUÁNDO ELEGIRLAS */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">¿Cuándo elegir mosquiteras fijas?</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {cuando.map((c, i) => (
                <motion.div
                  key={c.title}
                  className="bg-white rounded-[20px] p-8 text-center shadow-sm hover:shadow-md transition-shadow"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="text-4xl mb-4">{c.emoji}</div>
                  <h3 className="font-heading font-bold text-xl text-text-primary mb-2">{c.title}</h3>
                  <p className="font-body text-sm text-text-secondary leading-relaxed">{c.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* LIMITACIONES */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Limitaciones que debes conocer</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
              <p className="font-body text-lg text-text-secondary mt-4 max-w-2xl mx-auto">
                Antes de decidirte, te contamos las contras para que elijas con cabeza.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {limitaciones.map((l, i) => (
                <motion.div
                  key={l.title}
                  className="bg-surface-alt rounded-[20px] p-8 shadow-sm hover:shadow-md transition-shadow"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="w-12 h-12 bg-green-100 text-primary rounded-xl flex items-center justify-center mb-5">
                    <i className={`${l.icon} text-2xl`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-lg text-text-primary mb-2">{l.title}</h3>
                  <p className="font-body text-sm text-text-secondary leading-relaxed">{l.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* PRECIO */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Precio orientativo</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
            </div>
            <div className="max-w-xl mx-auto bg-white rounded-3xl p-8 md:p-12 text-center shadow-sm">
              <div className="font-heading font-extrabold text-5xl md:text-6xl text-primary mb-2">60-120 €</div>
              <p className="font-body text-lg text-text-secondary mb-6">por ventana estándar</p>
              <div className="flex flex-col gap-3 text-left max-w-sm mx-auto">
                <div className="flex items-center gap-2 font-body text-sm text-text-secondary"><span className="text-green-600">✓</span> Marco de aluminio lacado</div>
                <div className="flex items-center gap-2 font-body text-sm text-text-secondary"><span className="text-green-600">✓</span> Tela fibra de vidrio</div>
                <div className="flex items-center gap-2 font-body text-sm text-text-secondary"><span className="text-green-600">✓</span> Instalación incluida</div>
                <div className="flex items-center gap-2 font-body text-sm text-text-secondary"><span className="text-green-600">✓</span> Garantía 2 años</div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Preguntas frecuentes</h2>
                <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
              </div>
              <div className="space-y-4" itemScope itemType="https://schema.org/FAQPage">
                {faqs.map((f, i) => (
                  <motion.div
                    key={i}
                    className="bg-surface-alt rounded-2xl p-6 md:p-8"
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: i * 0.05 }}
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                  >
                    <h3 className="font-heading font-bold text-lg text-text-primary mb-2" itemProp="name">{f.q}</h3>
                    <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                      <p className="font-body text-sm text-text-secondary leading-relaxed" itemProp="text">{f.a}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-text-primary py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-white mb-4">
              Mosquitera fija desde 60€
            </h2>
            <p className="font-body text-lg text-slate-300 mb-8 max-w-2xl mx-auto">
              La protección más económica contra mosquitos. Te medimos gratis y te damos precio al momento.
            </p>
            <a
              href="tel:+34951120770"
              className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold text-lg px-8 py-4 rounded-pill transition-colors"
            >
              <span>📞</span> Llámanos: 951 12 07 70
            </a>
          </div>
        </section>

        {/* FORM */}
        <div id="presupuesto">
          <QuoteFormSection />
        </div>
      </main>
      <Footer />
      <WhatsAppFloating />
      <CookieBanner />
    </div>
  );
}